// src/reducers.js
import { combineReducers } from 'redux'
import appReducer from './components/app/reducer'
import heroReducer from './components/hero/reducer' 
import infoReducer from './components/info/reducer'
import lightboxReducer from './components/lightbox-container/reducer'
import artistsReducer from './components/artist-list-container/reducer'
import backgroundCanvasReducer from './components/background-canvas/reducer'
import caseStudiesReducer from './components/case-studies-container/reducer'
import artistCaseStudiesReducer from './components/artist-case-studies-container/reducer'
import collectionReducer from './components/collection-container/reducer'
import navigationReducer from './components/navigation/reducer'
import createPageReducer from './components/create-page/create-page-reducer'
import footerReducer from './components/main/reducer'

const rootReducer = combineReducers({
  app: appReducer,
  hero: heroReducer,
  info: infoReducer,
  artists: artistsReducer,
  caseStudies: caseStudiesReducer,
  artistCaseStudies: artistCaseStudiesReducer,
  backgroundCanvas: backgroundCanvasReducer,
  lightbox: lightboxReducer,
  collection: collectionReducer,
  navigation: navigationReducer,
  page_home: createPageReducer('HOME'),
  page_collection: createPageReducer('COLLECTION'),
  page_subcollection: createPageReducer('SUBCOLLECTION'),
  page_artist: createPageReducer('ARTIST'),
  page_artist_bio: createPageReducer('ARTIST_BIO'),
  page_artist_menu: createPageReducer('ARTIST_MENU'),
  page_lightbox_collection: createPageReducer('LIGHTBOX_COLLECTION'),
  page_lightbox_subcollection: createPageReducer('LIGHTBOX_SUBCOLLECTION'),
  page_info: createPageReducer('INFO'),
  footer: footerReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers.js